//#region src/loyalty_auth_method.ts
var LoyaltyAuthMethod = /* @__PURE__ */ function(LoyaltyAuthMethod) {
	LoyaltyAuthMethod[LoyaltyAuthMethod["Barcode"] = 1] = "Barcode";
	LoyaltyAuthMethod[LoyaltyAuthMethod["EmailPhoneNumber"] = 2] = "EmailPhoneNumber";
	LoyaltyAuthMethod[LoyaltyAuthMethod["EmailPassword"] = 3] = "EmailPassword";
	LoyaltyAuthMethod[LoyaltyAuthMethod["UsernamePassword"] = 4] = "UsernamePassword";
	LoyaltyAuthMethod[LoyaltyAuthMethod["PhoneNumber"] = 5] = "PhoneNumber";
	LoyaltyAuthMethod[LoyaltyAuthMethod["CardNumber"] = 6] = "CardNumber";
	LoyaltyAuthMethod[LoyaltyAuthMethod["Email"] = 7] = "Email";
	LoyaltyAuthMethod[LoyaltyAuthMethod["WebSessionToken"] = 8] = "WebSessionToken";
	LoyaltyAuthMethod[LoyaltyAuthMethod["ManualRedemption"] = 9] = "ManualRedemption";
	LoyaltyAuthMethod[LoyaltyAuthMethod["Hid"] = 10] = "Hid";
	return LoyaltyAuthMethod;
}(LoyaltyAuthMethod || {});
//#endregion
export { LoyaltyAuthMethod };

//# sourceMappingURL=loyalty_auth_method.js.map